<template>
  <div class="flex-grow">
    <div class="bg-theme-light">
      <div class="section container px-6 py-16 mx-auto">
          <div class="items-center lg:flex">
              <div class="w-full flex flex-col jusctify-center text-center">
                  <h1 class="text-5xl text-theme-blue font-semibold">{{title}}</h1>
                  <h4 class="text-gray-900 text-3xl w-11/12 md:w-9/12 m-auto text-center font-normal py-6">{{subtitle}}</h4>
              </div>
          </div>
      </div>
    </div> 
    <div v-show="authors && title" class="section container px-6 mt-10 mx-auto">  
      <div class="flex w-11/12 md:w-1/2 mx-auto justify-between flex-col space-y-5 md:space-y-1 md:flex-row">
          <button @click="showAll" :class="{'ring ring-theme-blue ring-offset-2 ring-opacity-30':this.showFull}" class="px-6 py-4 text-sm font-medium text-theme-blue uppercase transition-colors duration-200 transform bg-theme-light rounded-lg lg:w-auto focus:outline-none focus:bg-indigo-400 ">
              VER TODOS
          </button>          
          <button @click="showEs" :class="{'ring ring-theme-blue ring-offset-2 ring-opacity-50':this.filterEs}" class="px-6 py-4 text-sm font-medium text-white uppercase transition-colors duration-200 transform bg-theme-blue rounded-lg lg:w-auto focus:outline-none focus:bg-indigo-400 ">
              ESCRITORES
          </button>          
          <button @click="showIl" :class="{'ring ring-theme-sky ring-offset-2 ring-opacity-50':this.filterIl}" class="px-4 py-4 text-sm font-medium text-white uppercase transition-colors duration-200 transform bg-theme-sky rounded-lg lg:w-auto focus:outline-none focus:bg-indigo-400 ">
          ILUSTRADORES</button>
      </div>   
      <div class="flex w-11/12 md:w-1/2 mx-auto mt-6 justify-between items-center pr-4">
        <label class="text-xl" for="">BUSCAR: </label>
        <!-- <input  class="border border-gray-200 p-2 w-full ml-4 rounded-lg" type="text" placeholder="Ingrese el nombre del autor">  -->
        <label class="relative text-gray-400 focus-within:text-gray-900 block w-full">
              <!-- <svg xmlns="http://www.w3.org/2000/svg" class="pointer-events-none w-8 h-8 absolute top-1/2 transform -translate-y-1/2 left-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>             -->
              <input v-model="filtroInput" type="email" name="email" id="email" 
                     placeholder="Ingrese el nombre del autor" 
                     class="form-input border border-gray-200 p-2 mx-4 rounded-lg appearance-none w-full block px-2 focus:outline-none">
        </label>      
      </div>
      <div class="flex flex-col md:flex-row w-11/12 md:w-3/5 py-4 rounded-xl mx-auto mt-6 justify-evenly items-center bg-gray-50 ">
        <div class="text-gray-700 pl-2 mb-3 md:w-3/4">
          Si sos escritor o ilustrador completa el formulario para ser parte de nuestro directorio de autores locales. </div>
        <div>
          <router-link to="/autor-inscripcion" 
                       class="bg-theme-blue text-white py-2 px-3 rounded-lg text-sm">INSCRIBITE</router-link> 
        </div>
      </div>

    </div>

    <div class="section container px-6 py-16 mx-auto">  

        <div v-show="!authors" class="flex justify-center items-center"> 
          <div class="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-theme-sky"></div>
        </div>

        <div v-show="showFull" >
          <div v-for="letra in authors" :key="letra.id">
            <h2 class="text-5xl text-theme-blue font-semibold my-8 ">{{letra[0].letra}} </h2>
            <div class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
              <Item 
                  v-for="item in letra"
                  :key="item.id"
                  :item="item"
                  :filtroInput="this.filtroInput"
              />
            </div>
          </div>
        </div>

        <div v-show="this.filterEs">
          <div  v-for="letra in escritores" :key="letra.id">
            <h2 class="text-5xl text-theme-blue font-semibold my-8 ">{{letra[0].letra}} </h2>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
              <Item 
                  v-for="item in letra"
                  :key="item.id"
                  :item="item"
                  :filtroInput="this.filtroInput"
              />
            </div>
          </div>
        </div>

        <div v-show="this.filterIl">
            <div  v-for="letra in ilustradores" :key="letra.id">
              <h2 class="text-5xl text-theme-blue font-semibold my-8 ">{{letra[0].letra}} </h2>
              <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
                <Item 
                    v-for="item in letra"
                    :key="item.id"
                    :item="item"
                    :filtroInput="this.filtroInput"
                />
              </div>
            
            </div>

        </div>
    
        

      
    </div>

  </div> 

</template>

<script>
import Item from '@/components/autores/Item' 

export default {
  name: "Autores",     
  components: {
    Item
  },
  setup() {
      const img_banner = require('@/assets/images/home/banner1.svg')
      return {img_banner}
  },
  data(){
      return{
        authors:"",
        escritores:"",
        ilustradores:"",
        title:"",
        subtitle:"",
        filterIl:false,
        filterEs:false,
        showFull:true,
        filtroInput: ""        
      }
  },
  mounted () {
    window.scrollTo(0, 0)
  },   
  methods: {
    showIl(){
      this.showFull = false
      this.filterEs = false
      this.filterIl = true
      this.filtroInput = ""
    },    
    showEs(){
      
      this.showFull = false
      this.filterEs = true
      this.filterIl = false
      this.filtroInput = ""
    },    
    showAll(){
      this.showFull = true
      this.filterEs = false
      this.filterIl = false
      this.filtroInput = ""
    },

    hideletter(){

        const letras = document.querySelectorAll(".letra");
          letras.forEach(letra => {
            console.log(letra.textContent)
            
            let child  = letra.querySelectorAll('.item')
            console.log(child.length)
            if(child.length == 0){
                letra.classList.add("hidden")
            }else{
                letra.classList.remove("hidden")
            }
          });
    },

    async getContent(view){

      var filter = `?view=${view}`
      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/contents${filter}`
      const response = await fetch(get,{method: 'GET'})
      const contents = await response.json()

      this.title = contents.filter(obj => obj.section == 'header' && obj.element == 'title')[0].content
      this.subtitle = contents.filter(obj => obj.section == 'header' && obj.element == 'subtitle')[0].content
    },    
    async getAuthors(){
      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/authors`;
      const response = await fetch(get,{method: 'GET'})
      const listas = await response.json()
      this.authors = listas.full
      this.escritores = listas.escritores
      this.ilustradores = listas.ilustradores

      // let myTarget = JSON.parse(JSON.stringify(this.authors))
      // console.log(myTarget)
      // // this.escritores = this.authors.filter(obj => obj.type == 'escritor')
      // this.escritores = myTarget.forEach(a => a.filter(e => e.type == 'escritor' ))

      // // this.slides = this.libraries
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created(){
     this.getContent('autores')
     this.getAuthors()
  }
};
</script>
,